import { gql } from "@apollo/client";

export const GET_ONBOARDING_HEADER_QUERY = gql`
  query GetOnboardingReadinessHeader {
    getOnboardingReadiness {
      overallScore
      lenses {
        lensKey
        lensName
        overallScore
        assetScore
        evidenceScore
        locationScore
        connectionScore
        assetCount
      }
    }
  }
`;

export const GET_ONBOARDING_COMPLETENESS_QUERY = gql`
  query GetOnboardingReadinessCompleteness($lensKey: String) {
    getOnboardingReadiness(lensKey: $lensKey) {
      assetCompleteness {
        score
        total
        complete
        buckets {
          name
          fields
          pct
          filled
          total
          items {
            id
            name
            status
            typeName
            locationName
            locationAddress
          }
        }
      }
      locationCompleteness {
        score
        total
        complete
        buckets {
          name
          fields
          pct
          filled
          total
          items {
            id
            name
            status
            typeName
            locationName
            locationAddress
          }
        }
      }
      connectionsCompleteness {
        score
        total
        complete
        buckets {
          name
          fields
          pct
          filled
          total
          items {
            id
            name
            status
            typeName
            locationName
            locationAddress
          }
        }
      }
      evidenceCompleteness {
        score
        total
        complete
        buckets {
          name
          fields
          pct
          filled
          total
          items {
            id
            name
            status
            typeName
            locationName
            locationAddress
          }
        }
      }
    }
  }
`;
